import i18n from '../i18n';

/**
 * Function to convert UTC time to date in the system's local time zone
 * @param utcString - The UTC string to convert
 * @returns - The date in the local time zone
 */
function UTCtDateoDateConvert(utcString: string): string {
  if (!utcString) {
    return '';
  }

  const date = new Date(utcString);

  const options: Intl.DateTimeFormatOptions = {
    timeZone: 'UTC',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour12: false, // Not necessary for the date itself, but keeps it consistent
  };

  // Format the date to local time in the specified time zone
  const dateString = new Intl.DateTimeFormat(i18n.language, options).format(date);
  return dateString;
}

export default UTCtDateoDateConvert;
